export enum ReportsRoute {
  ProfitAndLoss = '/profit-and-loss',
  Balance = '/balance',
  TrialBalance = '/trial-balance',
}
